<script setup lang="ts">
definePageMeta({
  layout: 'kurs'
})

const { data: courses } = await useAsyncData('kurse-overview', () =>
  queryCollection('kurse')
    .where('courseType', 'IS NOT NULL')
    .order('path', 'ASC')
    .all()
)

const categories = [
  {
    title: 'Kurse für Eltern / Erziehungsberechtigte',
    description: 'Digitale Sicherheit, Medienkompetenz und praktische Tipps für Familien im Netz.',
    icon: 'i-lucide-users',
    to: '/kurs/eltern'
  },
  {
    title: 'Kurse für Senioren',
    description: 'Einfacher Einstieg in Smartphone, Tablet und Internet – Schritt für Schritt.',
    icon: 'i-lucide-heart-handshake',
    to: '/kurs/senioren'
  },
  {
    title: 'Web Development Kurse',
    description: 'Moderne Webentwicklung für Einsteiger und Fortgeschrittene – praxisnah und aktuell.',
    icon: 'i-lucide-code-2',
    to: '/kurs/web-dev'
  },
  {
    title: 'Smart Home für jedermann',
    description: 'Intelligente Geräte, Heimautomation und vernetzte Systeme verständlich erklärt.',
    icon: 'i-lucide-house-plus',
    to: '/kurs/smart-home'
  }
]

useSeoMeta({
  title: 'Kurse – WebProfessionals',
  ogTitle: 'Kurse – WebProfessionals',
  description: 'Alle Kursangebote von WebProfessionals – Web Development, Digitale Kompetenz für Eltern und mehr.',
  ogDescription: 'Alle Kursangebote von WebProfessionals – Web Development, Digitale Kompetenz für Eltern und mehr.'
})
</script>

<template>
  <UPage>
    <UPageHeader
      title="Kurse"
      description="Praxisnahe Weiterbildung – von Web Development bis Medienkompetenz für Eltern."
    />

    <UPageBody>
      <div class="prose dark:prose-invert max-w-none mb-10">
        <p>
          Wir bieten Kurse für Fachleute, Eltern und Senioren – stets praxisnah, aktuell und auf Augenhöhe.
          Wähle eine Kategorie und entdecke die passenden Angebote.
        </p>
      </div>

      <div class="grid gap-6 sm:grid-cols-2">
        <NuxtLink
          v-for="cat in categories"
          :key="cat.to"
          :to="cat.to"
          class="group"
        >
          <UCard class="h-full transition-shadow group-hover:ring-2 group-hover:ring-primary">
            <template #header>
              <div class="flex items-center gap-3">
                <UIcon
                  :name="cat.icon"
                  class="text-primary text-2xl shrink-0"
                />
                <h2 class="text-base font-semibold leading-tight">
                  {{ cat.title }}
                </h2>
              </div>
            </template>

            <p class="text-sm text-muted">
              {{ cat.description }}
            </p>

          <template #footer>
            <UButton
              variant="ghost"
              color="primary"
              trailing-icon="i-lucide-chevron-right"
              label="Kurse anzeigen"
              size="sm"
            />
          </template>
          </UCard>
        </NuxtLink>
      </div>

      <template v-if="courses?.length">
        <USeparator class="my-10" />

        <h2 class="text-xl font-semibold mb-4">
          Alle Kurse
        </h2>

        <div class="grid gap-4 md:grid-cols-2">
          <CoursetypeCard
            v-for="course in courses"
            :key="course.path"
            :title="course.title"
            :description="course.description"
            :slug="course.slug!"
            :to="course.path"
            :cover-image="course.coverImage"
            :level="course.level"
          />
        </div>
      </template>
    </UPageBody>
  </UPage>
</template>
